var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var ProjectAPI = /** @class */ (function (_super) {
    __extends(ProjectAPI, _super);
    function ProjectAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectAPI.prototype.interCompanyCosts = function (props) { return this.fetcher.get("/api/project/inter-company-cost", props); };
    ProjectAPI.prototype.listForAutoComplete = function () { return this.fetcher.get("/api/projects/auto-complete", {}); };
    ProjectAPI.prototype.list = function (props) { return this.fetcher.get("/api/projects", props); };
    ProjectAPI.prototype.getAddressMeta = function (props) { return this.fetcher.get("/api/project/get-address-meta", props); };
    ProjectAPI.prototype.autoComplete = function (props) { return this.fetcher.get("/api/projects/autocomplete", props); };
    ProjectAPI.prototype.get = function (id) { return this.fetcher.get("/api/project", { id: id }); };
    ProjectAPI.prototype.create = function (input) { return this.fetcher.post("/api/project/create", input); };
    ProjectAPI.prototype.update = function (input) { return this.fetcher.post("/api/project/update", input); };
    ProjectAPI.prototype.getAccountingSummary = function (input) { return this.fetcher.get("/api/project/accounting-summary", input); };
    ProjectAPI.prototype.costSummary = function (input) { return this.fetchPaginated("/api/project/costing-summary", input); };
    ProjectAPI.prototype.interCompanyInvoicing = function (input) { return this.fetchPaginated("/api/projects/inter-company-invoicing", input); };
    ProjectAPI.prototype.photos = function (input) { return this.fetcher.get("/api/project/photos", input); };
    return ProjectAPI;
}(SubAPI));
export { ProjectAPI };
